import { v4 as uuidv4 } from 'uuid';
import InvoiceCashOrderGridPluginSettings from '../pluginSettings/InvoiceCashOrderGridPluginSettings';
import { InvoiceCashOrderGridPluginView } from '../view/InvoiceCashOrderPluginView';

export const InvoiceCashOrderTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Приходные кассовые ордера',
        view: {
            content: InvoiceCashOrderGridPluginSettings
                ? <InvoiceCashOrderGridPluginView gridId={uuidv4()} plugin={InvoiceCashOrderGridPluginSettings} />
                : <p> Справочник не настроен </p>
        }
    }
}
export default InvoiceCashOrderTab